import React from 'react';
import { OptionGroupStatusChangeDialogProps } from './OptionGroupStatusChangeDialog.types';
import { LinkingType, OptionGroupDto } from '@/types';
import { OptionGroupUnitStatusDialog } from './OptionGroupUnitStatusDialog';
import { OptionGroupRoomStatusDialog } from './OptionGroupRoomStatusDialog';

export const OptionGroupStatusChangeDialog: React.FC<OptionGroupStatusChangeDialogProps<OptionGroupDto>> = ({
    optionGroup,
    ...rest
}) => {
    return optionGroup.linkType === LinkingType.Direct ? (
        <OptionGroupUnitStatusDialog optionGroup={optionGroup} {...rest} />
    ) : (
        <OptionGroupRoomStatusDialog optionGroup={optionGroup} {...rest} />
    );
};
